import PropTypes from 'prop-types';
import React from 'react';

import { SUPPORTED_ENRICHMENT_IDS } from 'app/hooks/useSyndeticsUnbound';
import './SyndeticsUnboundEnrichment.scss';

const SyndeticsUnboundEnrichment = ({ enrichmentId, hasTitle }) => {
  return (
    <div className="cp-syndetics-unbound-enrichment">
      {hasTitle && <div className={`unbound_${enrichmentId}_header`}></div>}
      <div className={`unbound_${enrichmentId}`}></div>
    </div>
  );
};

SyndeticsUnboundEnrichment.defaultProps = {
  hasTitle: true
};

SyndeticsUnboundEnrichment.propTypes = {
  enrichmentId: PropTypes.oneOf(Object.values(SUPPORTED_ENRICHMENT_IDS)).isRequired,
  hasTitle: PropTypes.bool
};

export default SyndeticsUnboundEnrichment;
